import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class AuthService implements CanActivate {

  private user: any = null;
  private observableUser: Observable<any> | null;

  constructor(
    private router: Router,
    private http: HttpClient,
  ) {}

  login(username: string, password: string): Observable<any> {
    return this.http.post('/api/auth/login', {email: username, password: password});
  }

  getProfile(): Observable<any> {
    return this.http.get('/api/auth/logged-user');
  }

  public profile(): Observable<any> {
    if (this.user) {
      return of (this.user);
    } else if (this.observableUser) {
      return this.observableUser;
    } else {
        this.observableUser = this.getProfile().pipe(
          map((user: any) => {
            return this.user = user;
          })
        );
        return this.observableUser;
    }
  }

  public isLoggedIn(): boolean {
    const token = localStorage.getItem('token');
    if (!token) {
      return false;
    }
    // @todo if token is invalid return false
    return true;
  }

  public isAdmin(): boolean {
      if (!this.user) {
          return false;
      }
      this.user.roles.forEach((role: any) => {
        if (role.name === 'role.admin'){
            return true;
        }
      });
      return false;
  }

  public clearUser(): void {
    this.user = null;
    this.observableUser = null;
  }

  public logout(): void {
    this.http.delete('/api/auth/logout').subscribe((response: any) => {
      localStorage.removeItem('token');
      this.clearUser();
      this.router.navigate(['/authentication/signin']);
    });

  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.isLoggedIn()) {
      this.router.navigate(['authentication/signin']);
      return false;
    }
    return true;
  }
}
